import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { CalendarService } from './calendar.service';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoggerService } from '@teammood/shared/util/logger';
import { Tag } from "@teammood/shared/ui/tags-input";
import { MoodsDistributionBarService } from "../timeline/moods-distribution-bar/moods-distribution-bar.service";
import { CalendarData, CalendarFilterServiceProps, DayForCalendar, MoodForCalendar } from "./calendar.type";
import {
    DateRangePickerPresetId,
    DateRangePickerService,
    DEFAULT_DATE_RANGE_PRESET_IDS
} from "@teammood/shared/ui/date-range-picker";
import { DateRange } from "@angular/material/datepicker";
import { FormControl } from "@angular/forms";
import { Subject, distinctUntilChanged, filter, from, mergeMap, takeUntil, tap } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    providers: [CalendarService, MoodsDistributionBarService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarComponent implements OnInit, OnDestroy {
    
    moodsDisplayTime: any; // didn't find if it's a date or string
    teamId: string;
    all_tags: Tag[];
    days: DayForCalendar[]
    moodsToCount: MoodForCalendar[]
    presetIds: DateRangePickerPresetId[];
    maxDate: Date;
    dateRange: DateRange<Date>;
    calendarFilterServiceProps: CalendarFilterServiceProps;

    protected dateRangeCtrl = new FormControl<DateRange<Date>>(null);

    private _destroy$ = new Subject<void>();

    constructor(
        private log: LoggerService,
        private calendarService: CalendarService,
        private moodsDistributionBarService: MoodsDistributionBarService,
        private snackBarService: SnackBarService,
        private dateRangePickerService: DateRangePickerService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {

        this.dateRange = this.dateRangePickerService.currentDateRange;
        this.dateRangeCtrl.setValue(this.dateRange);   
        this.presetIds = DEFAULT_DATE_RANGE_PRESET_IDS;
        this.maxDate  = new Date();

        this.route.params.pipe(
            filter(params => !!params['teamId']),
            mergeMap(params => {
                this.teamId = params['teamId'];
                this.calendarFilterServiceProps = {
                    teamId: params['teamId'],
                    selectedCombinator: 'any',
                    selected_tags: []
                }
                return from(this.retrieve_moods());
            }),
            takeUntil(this._destroy$)
        ).subscribe();

        this.dateRangeCtrl.valueChanges.pipe(
            distinctUntilChanged(),
            mergeMap((dateRange) => {
                this.dateRange = dateRange;
                return from(this.retrieve_moods());
            })
        ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async onTagSelection(data: CalendarFilterServiceProps){
        this.calendarFilterServiceProps = data;
        await this.retrieve_moods();
    }


    private async retrieve_moods() {
        return this.calendarService.moodsCalendar(this.dateRange, this.calendarFilterServiceProps.teamId, this.calendarFilterServiceProps.selected_tags, this.calendarFilterServiceProps.selectedCombinator)
            .then((response: CalendarData) => {
                this.moodsDisplayTime = response.moodsDisplayTime; // undefined
                this.all_tags = response.tags;
                this.days = this.calendarService.daysWithTransformedMoodsForCalendar(response.days);
                this.moodsToCount = this.moodsDistributionBarService.getMoodsOfAllDays(this.days)
            })
            .catch(error => {
                const err = error.data || error;
                this.log.error(err);
                this.snackBarService.error(err);
            });
    }
}

